module.exports = __webpack_public_path__ + "img/behance cover.d3a9e365.png";